import { workFlowFragment } from 'apollo/fragments/organization';
import { orderWorkFlowFragment } from 'apollo/fragments/order';
import { gql } from 'graphql.macro';

export const addStepTemplate = gql`
    mutation addStep(
        $name: String!
        $description: String!
        $maxHourInStep: Int!
        $defaultExtUsers: [MongoDbObjectId!]!
        $useMillingDeadline: Boolean
        $millingDeadlineDays: Int
        $initiatesSubcontract: Boolean
    ) {
        addStep(
            name: $name
            description: $description
            maxHourInStep: $maxHourInStep
            defaultExtUsers: $defaultExtUsers
            useMillingDeadline: $useMillingDeadline
            millingDeadlineDays: $millingDeadlineDays
            initiatesSubcontract: $initiatesSubcontract
        ) {
            ...workFlowFields
        }
    }
    ${workFlowFragment}
`;

export const updateStepTemplate = gql`
    mutation updateStep(
        $stepId: MongoDbObjectId!
        $name: String!
        $description: String!
        $maxHourInStep: Int!
        $defaultExtUsers: [MongoDbObjectId!]!
        $useMillingDeadline: Boolean
        $millingDeadlineDays: Int
        $initiatesSubcontract: Boolean
    ) {
        updateStep(
            stepId: $stepId
            name: $name
            description: $description
            maxHourInStep: $maxHourInStep
            defaultExtUsers: $defaultExtUsers
            useMillingDeadline: $useMillingDeadline
            millingDeadlineDays: $millingDeadlineDays
            initiatesSubcontract: $initiatesSubcontract
        ) {
            ...workFlowFields
        }
    }
    ${workFlowFragment}
`;

export const deleteStepTemplate = gql`
    mutation deleteStep($stepId: MongoDbObjectId!) {
        deleteStep(stepId: $stepId) {
            ...workFlowFields
        }
    }
    ${workFlowFragment}
`;

export const moveStepTemplate = gql`
    mutation moveStep($currentIndex: Int!, $newIndex: Int!) {
        moveStep(currentIndex: $currentIndex, newIndex: $newIndex) {
            ...workFlowFields
        }
    }
    ${workFlowFragment}
`;

export const defaultSampleStepTemplate = gql`
    mutation defaultSampleStep(
        $defaultNoSample: String
        $defaultPhysicalSample: String
        $defaultDigitalSample: String
    ) {
        defaultSampleStep(
            defaultNoSample: $defaultNoSample
            defaultPhysicalSample: $defaultPhysicalSample
            defaultDigitalSample: $defaultDigitalSample
        ) {
            ...workFlowFields
        }
    }
    ${workFlowFragment}
`;

export const changeWorkflowStepTemplate = gql`
    mutation changeWorkflowStep($orderCurrentStep: OrderCurrentStep!) {
        changeWorkflowStep(orderCurrentStep: $orderCurrentStep) {
            ...orderWorkFlowFields
        }
    }
    ${orderWorkFlowFragment}
`;

export const changeWorkflowStepForManyTemplate = gql`
    mutation changeWorkflowStepForMany($orderIds: [MongoDbObjectId]!, $orderCurrentStep: OrderCurrentStep!) {
        changeWorkflowStepForMany(orderIds: $orderIds, orderCurrentStep: $orderCurrentStep) {
            ...orderWorkFlowFields
        }
    }
    ${orderWorkFlowFragment}
`;

export const setSubcontractStatusRulesTemplate = gql`
    mutation setSubcontractStatusRules($supplierId: MongoDbObjectId!, $rules: [SubcontractStatusRuleInput!]!) {
        setSubcontractStatusRules(supplierId: $supplierId, rules: $rules) {
            supplierId
            rules {
                status
                stepId
            }
        }
    }
`;

export const pausedResumedStepTemplate = gql`
    mutation pausedResumedStep(
        $orderId: MongoDbObjectId!
        $userId: MongoDbObjectId!
        $comment: String
        $reason: String
    ) {
        pausedResumedStep(orderId: $orderId, userId: $userId, comment: $comment, reason: $reason) {
            ...orderWorkFlowFields
        }
    }
    ${orderWorkFlowFragment}
`;

export const startWorkTemplate = gql`
    mutation startWork($orderId: MongoDbObjectId!, $userId: MongoDbObjectId) {
        startWork(orderId: $orderId, userId: $userId) {
            ...orderWorkFlowFields
        }
    }
    ${orderWorkFlowFragment}
`;

export const completeWorkflowStepTemplate = gql`
    mutation completeWorkflowStep($orderId: MongoDbObjectId!, $userId: MongoDbObjectId) {
        completeWorkflowStep(orderId: $orderId, userId: $userId) {
            ...orderWorkFlowFields
        }
    }
    ${orderWorkFlowFragment}
`;
